import 'styles/global';

import ReactDOM from 'react-dom';
import { Provider as StoreProvider } from 'react-redux';
import Modal from 'react-modal';
import { createBrowserHistory } from 'history';
import { ConnectedRouter } from 'connected-react-router';
import { ThemeProvider } from 'roo-ui';
import { ModalGlobalStyle } from 'roo-ui/components';
import { ApolloProvider } from '@apollo/react-hooks';

import { ROUTER_BASENAME } from 'config/env';
import theme from 'styles/theme';
import App from 'components/App';
import createStore from 'store/createStore';
import { createClient } from 'lib/graphql';

import routes from './routes';

import { OAuthProvider } from 'hooks/useOAuth';
import { SplitFactory } from '@splitsoftware/splitio-react';
import getSplitUserId from 'utils/getSplitUserId';
import { SPLIT_API_KEY } from 'config';
import QFFWidgetSubscriber from 'components/QFFWidgetSubscriber';

const sdkConfig = {
  core: {
    authorizationKey: SPLIT_API_KEY,
    key: getSplitUserId(),
  },
};

export const initialize = () => {
  const history = createBrowserHistory({ basename: ROUTER_BASENAME });
  const { store, logicMiddleware } = createStore({ history });
  const client = createClient(store);

  logicMiddleware.addDeps({ client });

  const root = document.getElementById('root');

  history.listen(() => window.dataLayer.push({ event: 'gaPageview' }));

  Modal.setAppElement(root);

  ReactDOM.render(
    <SplitFactory config={sdkConfig}>
      <StoreProvider store={store}>
        <QFFWidgetSubscriber store={store} />
        <ApolloProvider client={client}>
          <ConnectedRouter history={history}>
            <OAuthProvider>
              <ThemeProvider theme={theme}>
                <ModalGlobalStyle />
                <App>{routes}</App>
              </ThemeProvider>
            </OAuthProvider>
          </ConnectedRouter>
        </ApolloProvider>
      </StoreProvider>
    </SplitFactory>,
    root,
  );
};
